/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Button, Flex, Icon, Result, Modal } from 'antd-mobile';
import jsBridge from '@/common/plugins/cmiotHelper/js-bridge';
import Header from '../common/header';
import './less/index.less';

const getQueryString = require('@/common/plugins/getQueryString');

class ConnectFailure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isBindedShow: false,
      isBindedContent: '',
    };
  }

  componentDidMount() {
    if (this.props.bindCameraStore.isAndroid) {
      jsBridge.send({
        f: 'FLAG_BACK_TYPE',
        tk: 'BACK_TYPE_NONE',
      });
    }
    if (getQueryString('isBinded')) {
      setTimeout(() => {
        this.isBinded();
      }, 50);
    }
  }

  componentWillUnmount() {
    if (this.props.bindCameraStore.isAndroid) {
      jsBridge.send({
        f: 'FLAG_BACK_TYPE',
        tk: 'BACK_TYPE_DEFAULT',
      });
    }
  }

  /**
   * 重新绑定 or 扫码
   * */
  returnPrev = val => () => {
    this.props.history.push(val);
  };

  /**
   * 已被其他用户绑定
   * */
  isBinded = () => {
    const { user, mac } = this.props.bindCameraStore.cameraInfo;
    const content = (
      <div className="bind-in-trouble trouble-tips">
        <p className="title">{user ? '出错原因' : '绑定失败，请尝试以下办法重新绑定：'}</p>
        {
          user
            ? [
              <p>{`该设备MAC：${mac}，已经被账号${user ? String(user).replace(String(user).substring(3, 7), 'XXXX') : 'XXX'}绑定。`}</p>,
              <p className="title">解决办法</p>,
              <p>如该账号不属于您：请点击“申请解绑”，审核周期为7个工作日！</p>,
              <br />,
              <p>如该该账号属于您：请切换该账号登陆和目，在“设备详情—参数设置—摄像机基本信息”自行解绑；</p>,
            ]
            : [
              <p>1. 使用移动宽带网络绑定摄像机；</p>,
              <p>2. 使用移动账号绑定摄像机；</p>,
              <p className="phone">
                如以上2种方案仍提示绑定失败，请拨打客服热线 10086；
              </p>,
            ]
        }
      </div>
    );
    this.setState({
      isBindedShow: true,
      isBindedContent: content,
    });
  };

  /**
   * 回到app首页
   * */
  goAppIndex = () => {
    jsBridge.send({
      f: 'FLAG_NEW_PAGE_LOCAL',
      tk: 'WINDOW_MAIN_PAGE',
    });
  };

  applyForUnbind = () => {
    this.closeIsBindedShow();
    jsBridge.send({
      f: 'FLAG_ADD_CAMERA',
      tk: 'ADD_CAMERA_GOTO_UNBIND',
    });
  };

  selfUnbind = () => {
    this.closeIsBindedShow();
    jsBridge.send({
      f: 'FLAG_NEW_PAGE_LOCAL',
      tk: 'WINDOW_APP_LOG_OUT',
    });
  };

  closeIsBindedShow = () => {
    this.setState({
      isBindedShow: false,
    });
  };

  render() {
    const { isSmartConfig, is4GDevice, cableBind, deviceName, cameraInfo } = this.props.bindCameraStore;
    const { isBindedShow, isBindedContent } = this.state;
    let isLocked = getQueryString('isLocked');
    const resultCode = getQueryString('resultCode');
    const resultThirdCode = getQueryString('resultThirdCode');

    let lockContent;
    if (resultThirdCode === '220008') {
      lockContent = '只允许使用移动宽带网络绑定该设备';
    } else if (resultThirdCode === '220009') {
      lockContent = '只允许移动手机号绑定该设备';
    } else if (resultThirdCode === '220003') {
      lockContent = '设备不存在！请联系客服10086处理！';
    } else if (resultThirdCode === '220012') {
      lockContent = '摄像机已被绑定';
    } else {
      isLocked = false;
    }

    return (
      <Flex direction="column" justify="between" className="connecting-container vh-100">
        <Header noBack="true" />
        <Flex.Item className="connect-fail-container">
          <Result
            img={<Icon type="cross-circle-o" className="spe" style={{ fill: '#ff2465' }} />}
            title={`${resultCode ? `绑定失败，错误码：${resultCode === '3' ? '连接超时' : resultCode}` : '绑定失败'}`}
            className="bind-result-mark"
          />
          <div className="connect-fail-container">
            {
              isLocked
                ? <p className="content lock">{lockContent}</p>
                : (is4GDevice
                  ? (
                    <p className="content">
                      {'1.请检查SIM卡是否正常插入'}
                      <br />
                      {'2.请检查SIM卡是否欠费'}
                      <br />
                      {'3.请检查4G网络是否正常'}
                    </p>
                  )
                  : (
                    <p className="content">
                      {'1.摄像机需要连接的网络无法正常通信'}
                      <br />
                      {'2.网络异常，摄像机无法连接服务器'}
                      <br />
                      {
                        resultCode
                          ? (
                            !cableBind
                              ? (
                                ['3.确保输入正确的2.4G频段Wi-Fi名称和密码', <br />, '4.如未解决，请记下错误码，联系客服热线：10086；']
                              ) : ('3.如未解决，请记下错误码，联系客服热线：10086；')
                          ) : (
                            !cableBind && '3.确保输入正确的2.4G频段Wi-Fi名称和密码'
                          )
                      }
                    </p>
                  ))
            }
          </div>
        </Flex.Item>
        <Flex.Item className="connect-fail-container">
          <div className="btn-container">
            <Button className="short-btn white-btn" type="primary" onClick={this.goAppIndex}>稍后再试</Button>
            {
              isSmartConfig
                ? <Button className="short-btn" type="primary" onClick={this.returnPrev('qrcode_wifi')}>扫描二维码</Button>
                : (
                  <Button
                    className="short-btn"
                    type="primary"
                    onClick={this.returnPrev(`reset_camera?deviceName=${deviceName}&fromH5=false`)}
                  >
                    {'重新绑定'}
                  </Button>
                )}
          </div>
        </Flex.Item>
        <Modal
          visible={isBindedShow}
          transparent
          maskClosable={false}
          onClose={this.closeIsBindedShow}
          title="温馨提示"
          footer={(cameraInfo && cameraInfo.user) ? [{ text: '申请解绑', onPress: () => { this.applyForUnbind(); } }, { text: '自行解绑', onPress: () => { this.selfUnbind(); } }] : [{ text: '我知道了', onPress: () => { this.closeIsBindedShow(); } }]}
        >
          {isBindedContent}
        </Modal>
      </Flex>
    );
  }
}

export default ConnectFailure;
